export type CompleteAddress = {
  address: string;
  city: string;
  postalCode: string;
  department: string;
  region: string;
  latitude?: number;
  longitude?: number;
};

export type AddressSuggestion = {
  address: string;
  fullAddress: string;
  city: string;
  department: string;
  department_code: string;
  postalCode: string;
  region_code: string;
  coordinates?: AddressCoordinates;
  short_code?: string;
};

export interface AddressCoordinates {
  latitude: number;
  longitude: number;
}

export enum AddressTypes {
  Address = 'address',
  City = 'place',
  Region = 'region',
}

interface FeatureProperties {
  mapbox_id: string;
  wikidata: string;
}

interface FeatureContext {
  id: string;
  mapbox_id: string;
  wikidata?: string;
  short_code?: string;
  text: string;
}

interface FeatureGeometry {
  type: string;
  coordinates: number[];
}

export interface AddressCoordinatesFeature {
  id: string;
  type: string;
  place_type: string[];
  relevance: number;
  properties: FeatureProperties;
  address?: string;
  text: string;
  place_name: string;
  bbox?: number[];
  center: number[];
  geometry: FeatureGeometry;
  context?: FeatureContext[];
}

export interface AddressCoordinatesSearchQueryResponse {
  type: string;
  query: string[];
  features: AddressCoordinatesFeature[];
  attribution: string;
}
